module.exports = __webpack_public_path__ + "img/approved.b34f642b.svg";